import { Modal } from '@mantine/core';
import { noop } from 'ui-components/default-props/noop';
import { useIntl } from 'react-intl';

import { ErrorBoundary } from '../../error-boundary';
import { PurchaseShipmentVolumeModalContent } from './purchase-shipment-volume-modal-content';
import { messages } from '../../purchase-shipment-volume/messages';
import { useShipmentUsageSummary } from '../../purchase-shipment-volume/use-shipment-usage-summary';

export type PurchaseShipmentVolumeModalView = 'purchase' | 'changePaymentMethod';

export type PurchaseShipmentVolumeModalProps = {
  onClose?: () => void;
  onPurchaseSuccess?: () => void;
  opened: boolean;
  initialQuantity?: number | null;
  initialView?: PurchaseShipmentVolumeModalView;
};

export const PurchaseShipmentVolumeModal = ({
  onClose = noop,
  onPurchaseSuccess,
  opened,
  initialQuantity,
  initialView,
}: PurchaseShipmentVolumeModalProps) => {
  const intl = useIntl();
  const { isAtLimit, isHighLimitWarning, isMediumLimitWarning, usagePercentage } = useShipmentUsageSummary();

  let titleMessage = messages.purchaseAdditionalShipmentsTitle;
  if (isAtLimit) {
    titleMessage = messages.atLimitTitle;
  } else if (isHighLimitWarning || isMediumLimitWarning) {
    titleMessage = messages.approachingLimitTitle;
  }
  const title = intl.formatMessage(titleMessage);

  return (
    <ErrorBoundary errorMessageId='purchaseShipmentVolumeModal' onError={onClose}>
      <Modal onClose={onClose} opened={opened} size='md' title={title}>
        <PurchaseShipmentVolumeModalContent
          initialQuantity={initialQuantity}
          initialView={initialView}
          isAtLimit={isAtLimit}
          isHighLimitWarning={isHighLimitWarning}
          isMediumLimitWarning={isMediumLimitWarning}
          onClose={onClose}
          onPurchaseSuccess={onPurchaseSuccess}
          usagePercentage={usagePercentage}
        />
      </Modal>
    </ErrorBoundary>
  );
};
